<template>
  <div class="RightMenu">
    <!-- <div class="menu menu-experience-container" @click="openYunPage">
      <div class="experience-preview">
        <img :src="`${$CdnServerAddress}websit/web/human.png`" />
      </div>
      <div class="experience-title">
        <div>数字人</div>
        <div>立即开始交互</div>
      </div>
    </div> -->
    <div class="menu menu-wechat-container">
      <div class="wechat-preview">
        <img :src="`${$CdnServerAddress}websit/web/wxcode.png`" />
      </div>
      <div class="wechat-title">
        <div>观看更多</div>
        <div>视频案例</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RightMenu",
  methods: {
    openYunPage() {
      window.open(
        "https://qt.bdbdigital.com/yihuaTxyunPreview?id=v7PjCX&cloudRenderId=cap-hjng8yde",
        "_blank"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.RightMenu {
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translate(0, -50%);
  color: #ffffff;
  font-size: 14px;
  z-index: 9;

  .menu {
    background: #141414;
    border-radius: 8px;
    overflow: hidden;
    width: 116px;
    cursor: pointer;

    &.menu-experience-container {
      margin-bottom: 20px;

      .experience-preview {
        img {
          width: 100%;
        }
      }

      .experience-title {
        padding: 6px 0;
        text-align: center;

        div {
          line-height: 22px;
        }
      }
    }

    &.menu-wechat-container {
      .wechat-preview {
        padding: 16px 16px 0;

        img {
          width: 100%;
        }
      }

      .wechat-title {
        padding: 6px 0;
        text-align: center;

        div {
          line-height: 22px;
        }
      }
    }
  }
}
</style>